<template>
  <!-- 添加dom记得适应手机端 -->
  <div id="mapview" class="mapcontainer">
    <!-- <div class="infoview">
      <input
        id="btnStart"
        @click="startRotate"
        type="button"
        class="btn btn-primary"
        value="开始"
      />
      <input
        id="btnStop"
        @click="stopRotate"
        type="button"
        class="btn btn-primary"
        value="停止"
      />
      <input
        id="btnStop"
        @click="flyTo"
        type="button"
        class="btn btn-primary"
        value="flyTo"
      />
    </div> -->
    <div class="infoview">
      <span>轨迹开始时间</span>
      <el-date-picker
        v-model="elStartDate"
        type="datetime"
        :clearable="false"
        placeholder="选择开始时间"
        @change="changeStartDate"
        default-time="14:44:00">
      </el-date-picker>
    </div>
    <Map :url="configUrl" @onload="onMapload" />
  </div>
</template>

<script>
import Map from "../../components/mars3d/Map.vue"
export default {
  components: {
    Map,
  },
  data() {
    const basePathUrl = window.basePathUrl || ""
    return {
      configUrl: basePathUrl + "static/mapconfig/config2.json", // 配置文件
      // 地图对象
      map: {},
      graphicLayer: {},
      data:[],
      timeStep: 5,
      lastTime: '',
      elStartDate: '',
      inter: 0,
      carList: [{id:1012001, name:'测试'}]
    }
  },
  methods: {
    // 地图构造完成回调
    onMapload(map) {
      console.log("地图构造完成")
      this.map = map
      // this.startRotate()
      this.elStartDate = new Date('2022-02-22 14:44:31')
      map.clock.currentTime = Cesium.JulianDate.fromDate(this.elStartDate)
      // 创建矢量数据图层
      this.graphicLayer = new mars3d.layer.GraphicLayer({
        chinaCRS: "GCJ02"
      })
      map.addLayer(this.graphicLayer)
      this.showCarList(this.carList)
    },
    showCarList(arr) {
      const { map, mars3d, graphicLayer } = this

      // 鼠标移入提示信息
      graphicLayer.bindTooltip(function (event) {
        const data = event.graphic.options
        return "编号: " +  data.id + "<br/>电量: " + data.elv
      })

      // 单击地图空白处
      map.on(mars3d.EventType.clickMap, function (event) {
        if (lastClickCar) {
          lastClickCar.removeShading("circle")
          lastClickCar = null
        }
      })

      // 绑定点击事件
      graphicLayer.on(mars3d.EventType.click, (event, position) => {
        const car = event.graphic

        if (lastClickCar) {
          if (lastClickCar === car) {
            return
          } // 重复单击，跳出
          lastClickCar.removeShading("circle")
          lastClickCar = null
        }

        car.addShading({
          type: "circle",
          materialType: mars3d.MaterialType.CircleWave,
          speed: 10,
          count: 3,
          gradient: 0.1,
          radius: 50,
          color: "#ffff00",
          opacity: 0.3,
          show: true,
        })
        lastClickCar = car

        // 视角定位下
        car.flyToPoint({ radius: 1000 })
      })

      let lastClickCar

      for (let i = 0; i < arr.length; i++) {
        const item = arr[i]

        item.show = true

        let modelParam = {
              scale: 2,
              url: "./static/glb/gongren.glb",
            }

        const car = new mars3d.graphic.DynamicRoamLine({
          id: item.id,
          name: item.name,
          elv: 30,
          model: {
            clampToGround: true,
            show: true,
            ...modelParam,
          },
          label: {
            text: item.id + '\n电量:30',
            addHeight: 30
          },
          shadow: [
            {
              type: "polyline",
              color: "rgb(40, 40, 255)",
              width: 2,
              clampToGround: true,
              maxDistance: 500,
              show: true,
            },
          ],
        })
        graphicLayer.addGraphic(car)
      }

      // 定时获取卡车和铲车的列表数据
      this.createPath()
    },
    // 首次获取并创建轨迹
    createPath() {
      const { map, mars3d } = this
      // 取数据的时间范围，结束时间
      const date = Cesium.JulianDate.toDate(map.clock.currentTime)
      const endTime = mars3d.Util.formatDate(date, "yyyy-MM-dd HH:mm:ss")

      // 修改当前时间回退一分钟，因为数据永远是当前时间之前的。
      date.setSeconds(date.getSeconds() - 60)
      map.clock.currentTime = window.Cesium.JulianDate.fromDate(date)

      // 取数据的时间范围，开始时间
      date.setMinutes(date.getMinutes() - 1) // 初次取一定时间内的数据
      const beginTime = mars3d.Util.formatDate(date, "yyyy-MM-dd HH:mm:ss")

      // 记录最后一次读取数据的时间
      this.lastTime = endTime

      // 取数据
      this.getPathList(beginTime, endTime)

      // 定时更新
      this.inter = setInterval(() => {
        this.updatePath()
      }, this.timeStep * 1000)
    },
    // 后续更新轨迹
    updatePath() {
      const beginTime = this.lastTime

      const date = new Date(beginTime)
      date.setSeconds(date.getSeconds() + this.timeStep)
      // date.setMinutes(date.getMinutes() + this.timeStep)
      const endTime = mars3d.Util.formatDate(date, "yyyy-MM-dd HH:mm:ss")

      this.lastTime = endTime

      // 取数据
      this.getPathList(beginTime, endTime)
    },
    // 读取车辆gps坐标路径的接口
    getPathList(beginTime, endTime) {
      const { data, graphicLayer, mars3d } = this
      const d_beginTime = new Date(beginTime)
      const d_endTime = new Date(endTime)
      /*
      const list = data.filter((item) => {
        const thistime = new Date(item.time)
        return thistime >= d_beginTime && thistime <= d_endTime
      })

      // 循环车辆
      graphicLayer.eachGraphic((car) => {
        // 取出对应车辆的轨迹列表
        // const path = list.filter((item) => {
        //   return item.id === car.id
        // })
        const path = list
        console.log(path)
        if (path && path.length > 0) {
          const p = path.map(e => {
            const time = mars3d.Util.formatDate(new Date(e.time), "yyyy-MM-dd HH:mm:ss")
            return {
              time: time,
              lng: e.lng,
              lat: e.lat
            }
          })
          // 更新车辆的轨迹
          car.updatePath(p, {
            timeColumn: "time",
            getPosition: function (item) {
              return Cesium.Cartesian3.fromDegrees(
                parseFloat(item.lng),
                parseFloat(item.lat),
                0
              )
            },
          })
        }
      })
      */
      mars3d.Resource.fetchJson({
        url: this.websiteUrl2 +  "/app/getRoamLine?endTime=" + endTime + "&startTime=" + beginTime,
      })
        .then((res) => {
          // console.log(res)

          const path = res.data

          // console.log(path)
          // 循环车辆
          graphicLayer.eachGraphic((car) => {
            // 取出对应车辆的轨迹列表
            // const path = list.filter((item) => {
            //   return item.id === car.id
            // })

            if (path && path.length > 0) {
              car.options.elv = path[0].elv
              // 更新车辆的轨迹
              car.updatePath(path, {
                timeColumn: "time",
                getPosition: function (item) {
                  return Cesium.Cartesian3.fromDegrees(
                    parseFloat(item.lng),
                    parseFloat(item.lat),
                    0
                  )
                },
              })
            }
          })
        })
        .otherwise(() => {
          globalMsg("实时查询车辆路径信息失败，请稍候再试")
        })
    },
    changeStartDate(date) {
      const { map, graphicLayer } = this
      clearInterval(this.inter)
      graphicLayer.disableEdit()
      graphicLayer.clear(true)
      map.clock.currentTime = Cesium.JulianDate.fromDate(date)
      this.showCarList(this.carList)
    },
    // 跳转
    flyTo() {
      const { map } = this
      this.stopRotate()
      let extent = {
        // 矩形视角经度范围
        xmin: 102.2149,
        xmax: 102.2158,
        // 矩形视角纬度范围
        ymin: 29.7534,
        ymax: 29.7555,
        // 视角高度
        height: 1875,
      }
      let options = {
        duration: 5,
        // 视角旋转角度
        pitch: -90,
        // 方向角度值
        heading: 89,
      }
      map.flyToExtent(extent, options)
    },
    // 地球旋转
    startRotate() {
      const { map, mars3d } = this
      // 距离地面过近时，先回到初始状态
      if (map.getCameraDistance() < 1000000) {
        map.flyHome({ duration: 3 })
      }
      this.stopRotate()

      this.previousTime = map.clock.currentTime.secondsOfDay
      map.on(mars3d.EventType.clockTick, this.map_onClockTick)
    },
    stopRotate() {
      const { map, mars3d } = this
      map.off(mars3d.EventType.clockTick, this.map_onClockTick)
    },
    map_onClockTick(clock) {
      const { map } = this
      let spinRate = 150
      let currentTime = map.clock.currentTime.secondsOfDay
      let delta = (currentTime - this.previousTime) / 1000
      this.previousTime = currentTime
      map.scene.camera.rotateRight(-spinRate * delta)
    },
  },
}
</script>

<style >
.mapcontainer {
  position: relative;
  height: 100%;
  overflow: hidden;
}
.infoview {
  position: absolute;
  top: 0.6rem;
  left: 0.6rem;
  padding: 0.6rem 0.9rem;
  border-radius: 0.2rem;
  border: 1px solid rgba(128, 128, 128, 0.5);
  color: #ffffff;
  background: rgba(0, 0, 0, 0.4);
  box-shadow: 0 0.2rem 0.9rem rgb(128 128 128 / 50%);
  z-index: 19870101;
}
.infoview2 {
  position: absolute;
  top: 0.6rem;
  left: 19.3rem;
  padding: 0.6rem 0.9rem;
  border-radius: 0.2rem;
  border: 1px solid rgba(128, 128, 128, 0.5);
  color: #ffffff;
  background: rgba(0, 0, 0, 0.4);
  box-shadow: 0 0.2rem 0.9rem rgb(128 128 128 / 50%);
  z-index: 19870101;
}
.btn {
  display: inline-block;
  padding: 0.4rem 0.8rem;
  margin-bottom: 0;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 0.2rem;
  outline: none;
}
.btn-primary {
  color: #fff;
  background-color: rgba(32, 160, 255, 0.2);
  border: 1px solid #e4eaec;
}
.checkbox {
  padding-left: 0.3rem;
}
.checkbox-inline {
  position: relative;
  display: inline-block;
  margin-bottom: 0;
  font-weight: normal;
  vertical-align: middle;
  cursor: pointer;
}
input[type="checkbox"] {
  width: 0.8rem;
  height: 0.8rem;
}
.checkbox label {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  padding-bottom: 0.3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/helmet/dynamicRoamLine.vue